// extracted by mini-css-extract-plugin
export default {"action-buttons":"ActionButtons_action-buttons__mqK0X","right-buttons":"ActionButtons_right-buttons__FuLYG"};